let MotionEffects = {
  data () {
    return {
      risingEl: document.querySelectorAll('[data-effect-slide] > *')
    }
  },
  methods: {
    risingEffect (interval) {
      const triggerBottom = window.innerHeight / 5 * 4.7
      document.querySelectorAll('[data-effect-slide] > *').forEach((el, index) => {
        if (!el.classList.contains('no_effect')) {
          const elTop = el.getBoundingClientRect().top
          if (elTop < triggerBottom) {
            el.dataset.effectExecute = true
            el.style.transitionDelay = index * interval + 's'
          } else {
            delete el.dataset.effectExecute
            el.style.transitionDelay = 0 + 's'
          }
        }
      })
    },
    clickEffect (event) {
      let currentTarget = event.currentTarget
      delete currentTarget.dataset.effectExecute
      setTimeout(() => {
        currentTarget.dataset.effectExecute = true
      }, 0)
    }
  },
  mounted () {
    if (document.querySelectorAll('[data-effect-slide] > *').length > 0) {
      this.risingEffect(0.038)
      this.scrollHandler = () => this.risingEffect(0)
      document.addEventListener('scroll', this.scrollHandler)
    }
    this.clickHandler = (e) => this.clickEffect(e)
    document.querySelectorAll('[data-effect-event=click]').forEach((el, index) => {
      el.addEventListener('click', this.clickEffect)
    })
  },
  beforeDestroy () {
    if (this.scrollHandler) {
      document.removeEventListener('scroll', this.scrollHandler)
    }
    if (this.clickHandler) {
      document.querySelectorAll('[data-effect-event=click]').forEach((el) => {
        el.removeEventListener('click', this.clickHandler)
      })
    }
  }
}
export default MotionEffects



// WEBPACK FOOTER //
// ./src/assets/js/MotionEffects.js